import { JsonObject, JsonProperty } from 'json2typescript';
import { OperativeResendSmsResponseInterface } from '../interfaces/resendSms.response.interface';

@JsonObject('OperativeResendSmsResponseModel')
export class OperativeResendSmsResponseModel
  implements OperativeResendSmsResponseInterface
{
  @JsonProperty('Message', String, true)
  message: string = undefined;

  @JsonProperty('Status', String, true)
  status: string = undefined;

  @JsonProperty('VerificationId', String, true)
  verificationId: string = undefined;
}
